var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class Filter {
  constructor(_data) {
    /**
     */
    __publicField(this, "ComplianceUploadType");
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "Statuses");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Filter
     */
    __publicField(this, "$type", "V1.ComplianceUploads.Search.Filter");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.ComplianceUploadType = FilterComplianceUploadType[_data["ComplianceUploadType"]];
      this.CountryCode = _data["CountryCode"];
      if (_data["Statuses"] && _data["Statuses"].constructor === Array) {
        this.Statuses = [];
        for (let item of _data["Statuses"]) {
          this.Statuses.push(FilterStatuses[item]);
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["ComplianceUploadType"] = FilterComplianceUploadType[this.ComplianceUploadType];
    _data["CountryCode"] = this.CountryCode;
    if (this.Statuses && this.Statuses.constructor === Array) {
      _data["Statuses"] = [];
      for (let item of this.Statuses) {
        _data["Statuses"].push(FilterStatuses[item]);
      }
    }
    return _data;
  }
}
export var FilterComplianceUploadType = /* @__PURE__ */ ((FilterComplianceUploadType2) => {
  FilterComplianceUploadType2["IOSS"] = "IOSS";
  FilterComplianceUploadType2["VAT"] = "VAT";
  return FilterComplianceUploadType2;
})(FilterComplianceUploadType || {});
export var FilterStatuses = /* @__PURE__ */ ((FilterStatuses2) => {
  FilterStatuses2["New"] = "New";
  FilterStatuses2["WaitingForFinalize"] = "WaitingForFinalize";
  FilterStatuses2["InvalidData"] = "InvalidData";
  FilterStatuses2["SaftCompliance"] = "SaftCompliance";
  FilterStatuses2["MasterDataSetup"] = "MasterDataSetup";
  FilterStatuses2["DataUploadFinalized"] = "DataUploadFinalized";
  FilterStatuses2["SentToReturnGeneration"] = "SentToReturnGeneration";
  FilterStatuses2["DataVatGenerated"] = "DataVatGenerated";
  FilterStatuses2["InsufficientCredit"] = "InsufficientCredit";
  FilterStatuses2["UploadProcessed"] = "UploadProcessed";
  FilterStatuses2["Error"] = "Error";
  return FilterStatuses2;
})(FilterStatuses || {});
